import React from 'react';
import { TouchTarget } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import cn from 'classnames';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { IconFilterSvg } from 'apps/sigma2-ui/src/filters-v2/components/IconFilter';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export interface SecondaryFilterButtonProps {
  /**
   * Callback when the button is clicked
   */
  onClick: () => void;

  /**
   * Whether the button is disabled
   */
  disabled: boolean;

  /**
   * Whether the button is active (this turns it blue similiar to hover, but only if disabled is false)
   */
  active: boolean;

  /**
   * Translated content for the left side of the button
   */
  translatedContent: TranslatedContent;
}

export const SecondaryFilterButton = ({
  onClick,
  disabled,
  active,
  translatedContent,
}: SecondaryFilterButtonProps) => {
  return (
    <div className={'inline-block max-w-full'}>
      <TouchTarget
        disabled={disabled}
        content={({ hovered }) => {
          return (
            <span
              className={cn(
                'flex rounded py-2 px-3 border-[1px] gap-2 items-center transition-all',
                {
                  'opacity-50 cursor-not-allowed': disabled,
                  'opacity-100 cursor-pointer': !disabled,
                  'bg-white border-gray-200': !hovered && !active,
                  'bg-royal-100 border-royal-400': hovered || active,
                },
              )}
            >
              <IconFilterSvg
                svg={{
                  className: cn('w-[1em] h-[1em] transition-all', {
                    'text-royal-700': hovered || active,
                    'text-gray-900': !hovered && !active,
                  }),
                }}
              />

              <S2Typography
                translatedContent={translatedContent}
                variant={'headline-7-alt'}
                textColorVariant={hovered || active ? 'royal-700' : 'gray-900'}
              />
            </span>
          );
        }}
        behavior={{ type: 'onClick', onClick }}
      ></TouchTarget>
    </div>
  );
};
